import React, { useEffect, useState } from "react";
import { Box, useToast } from "@chakra-ui/react";
import { TConfirmation } from "../types";
import CTACardWithConfirmation from "../../../UI/CTACardWithConfirmation";
import CollapsibleInformation from "../../../UI/CollapsibleInformation";
import walletService from "../../../../Services/WalletService";
import { toastError, toastSuccess } from "../../../../config/toast";
import { chainbridgeConfig } from "../../../../chainbridgeConfig";
import config from "../../../../config/config.json";
import BWLOGO from "../../../../media/logos/pn_logomark_bw.svg";

const configurations = (networkId: number) => {
  const network = config.chains.find(
    (network) => network.networkId === networkId
  );
  return [
    {
      name: "Use the following table to add a custom network RPC manually:",
      title: "Add the Palm Network",
      desc: "Click the button below to add the Palm Network as a custom network in your wallet.",
      buttonCopy: "Add Network",
      collapsibleTitle: "Manually add the network instead",
      table: [
        {
          field: "Network Name",
          input: network && network.name,
        },
        {
          field: "New RPC URL",
          input: [network && network.rpcUrl],
        },
        {
          field: "Chain ID",
          input: parseInt(process.env.REACT_APP_PALM_NETWORK_ID as string),
        },
        {
          field: "Currency Symbol *",
          input: network && network.nativeTokenSymbol,
        },
        {
          field: "Block Explorer URL *",
          input: [network && network.blockExplorer],
        },
      ],
      help: {
        text: "Metamask FAQ: How to add custom Network RPC →",
        url: "https://metamask.zendesk.com/hc/en-us/articles/360043227612-How-to-add-custom-Network-RPC-and-or-Block-Explorer",
      },
      check: "I have added the network",
    },
  ];
};

const AddPalmNetwork = ({ onConfirmation, step }: TConfirmation) => {
  const [collapse, setCollapse] = useState(false);
  const [validated, setValidated] = useState(false);
  const [networkStatus, setNetworkStatus] = useState(
    configurations(
      parseInt(process.env.REACT_APP_PALM_NETWORK_ID as string)
    ).map((network) => false)
  );

  useEffect(() => {
    if (validated) {
      onConfirmation(step, validated);
    }
  }, [validated]);

  const toast = useToast();

  const networkConfirmed = (index: number, checked: boolean) => {
    let newNetworkStatus = networkStatus;
    newNetworkStatus[index] = checked;
    setNetworkStatus(newNetworkStatus);
    const enabled = !newNetworkStatus.includes(false);
    setValidated(enabled);
  };

  const onClick = async () => {
    const networkId = chainbridgeConfig.palmNetwork;
    const status = await walletService.addNetworkToWallet(networkId);
    if (status) {
      setValidated(status);
      toast({
        title: "Network succesfully added to your wallet.",
        ...toastSuccess,
      });
      networkConfirmed(step, true);
    } else {
      toast({
        title: "Something was wrong",
        description: "You can add the Palm Network manually to your wallet.",
        ...toastError,
      });
      setCollapse(!collapse);
    }
    return status;
  };

  return (
    <>
      {configurations(
        parseInt(process.env.REACT_APP_PALM_NETWORK_ID as string)
      ).map((network, index) => (
        <Box key={`Add-network-${network.name}-card`}>
          <CTACardWithConfirmation
            name={network.name}
            title={network.title}
            desc={network.desc}
            buttonCopy={network.buttonCopy}
            onConfirmation={(index: number, checked: boolean) =>
              networkConfirmed(index, checked)
            }
            index={index}
            check={network.check}
            buttonOnClick={onClick}
            logo={BWLOGO}
            addInformation={
              <CollapsibleInformation
                title={network.collapsibleTitle}
                table={network.table}
                itemName={network.name}
                help={network.help}
                collapse={collapse}
                optional
              />
            }
          />
        </Box>
      ))}
    </>
  );
};
export default AddPalmNetwork;
